import {PolymerElement} from '@polymer/polymer/polymer-element.js';
import {html} from '@polymer/polymer/lib/utils/html-tag.js';
import template from './ns-product-variant-selector.html';
import {events, util} from '@nuskin/ns-util';
import {ProductService} from '@nuskin/ns-shop';

import '@nuskin/ns-style-elements';

/**
 * The ns-product-variant-selector should be used for
 *
 * <h1>Product Variant Selector</h1>
 * <demo-snippet class="demoSnippet">
 *   <template>
 *     <ns-product-variant-selector class="demoElement"></ns-product-variant-selector>
 *   </template>
 * </demo-snippet>
 *
 */
export class NsProductVariantSelector extends PolymerElement {
    constructor() {
        super();
    }

    ready() {
        super.ready();
        this.settingVariants = false;
        this.setListeners();
    }

    static get is() {
        return "ns-product-variant-selector";
    }

    static get template() {
        let htmlElement = document.createElement('TEMPLATE');
        htmlElement.innerHTML = template;
        return htmlElement;
    }

    static get properties() {
        return {
            /**
             * Disables input
             */
            disabled: {
                type: Boolean,
                reflectToAttribute: true
            },
            /**
             * Toggles functionality if logged in
             */
            isLoggedIn: Boolean,
            /**
             * Toggles functionality if touch device
             */
            isTouchDevice: {
                type: Boolean,
                value: util.MobileUtils.isMobileLike(),
                reflectToAttribute: true
            },
            /**
             * Dropdown label
             */
            label: String,
            /**
             * Returns product data from dropdown selection
             */
            newVariant: {
                type: Object,
                notify: true
            },
            /**
             * Toggles the visibility of the modal
             */
            opened: {
                type: Boolean,
                value: false,
                reflectToAttribute: true
            },
            /**
             * Variant object array
             */
            variants: {
                type: Array,
                value: []
            },
            /**
             * Placeholder text
             */
            variantDropdownPlaceholder: {
                type: String,
                value: ""
            },
            /**
             * Which number in the dropdown is selected
             */
            variantIndex: {
                type: Number,
                value: -1,
                notify: true
            },
            /**
             * Array of variant skus
             */
            variantSkus: {
                type: Array,
                value: [],
                observer: "_setVariants"
            },
            /**
             * Variant type
             * ie: "shade", "size"
             */
            variantType: {
                type: String,
                value: "shade"
            },
            /**
             * Sku of the current product
             */
            sku: String,
            /**
             * Sku component initialized with
             */
            initSku: String
        };
    }

    /**
     * Adds Product Variant Selector Modal to the DOM if it doesn't yet exist
     */
    addProductVariantSelectorModal() {
        if (!document.querySelector('ns-product-variant-selector-modal')) {
            document.querySelector('body').appendChild(document.createElement('ns-product-variant-selector-modal'));
        }
    }

    /**
     * Disables input
     */
    disable() {
        this.$.variantDropdown.disable();
    }

    /**
     * Enables input
     */
    enable() {
        this.$.variantDropdown.enable();
    }

    /**
     * Create all event listeners for this component
     */
    setListeners() {
        if (this.isTouchDevice) {
            this.$.variantDropdown.addEventListener("click", e => {
                this.addProductVariantSelectorModal();
                events.publish(events.shop.SHOW_PRODUCT_VARIANT_SELECTOR_MODAL, this);
            });
            events.subscribe(events.shop.HIDE_PRODUCT_VARIANT_SELECTOR_MODAL, data => {
                if (data.originalSku === this.initSku) {
                    this.newVariant = data.newVariant;
                    this.variantIndex = data.index;
                }
            });
        }

        this.$.variantDropdown.addEventListener('nsDropdownSelect', e => {
            if (!this.$.variantDropdown.pristine && !this.settingVariants) this.newVariant = this.variants[e.detail.index];
        });
    }

    /**
     * Makes call for each sku in variant-skus array for the list
     */
    _setVariants() {
        let index = 0;
        this.set("variants", []);
        if (this.variantSkus) {
            this.settingVariants = true;
			this.variantSkus.map(sku => {
				ProductService.getProductData(sku).then((data) => {
					if (data.sku === this.sku) {
                        this.variantIndex = index;
                    }
					this.push("variants", data);
                    index++;
                    if (this.variantSkus.length === index) {
                        this.settingVariants = false;
                    }

				});
			});
        }
    }

}
customElements.define(NsProductVariantSelector.is, NsProductVariantSelector);